module.exports = __webpack_public_path__ + "static/media/WebDevelopment.c9b282c0.JPG";